import React from "react";
import { Card, DataTable, KeyValueList, Table, ValueOrPlaceholder, } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectFilter, selectFocusedRow, } from "../../../../store/saasbomSlice";
import { ExpandedRowDetails } from "../../../../ui";
import { IssuesList, ServiceSummary } from "../../../common";
import { useReportDispatch, useReportSelector } from "../../../hooks";
import { SERVICE_TYPE_TO_TEXT } from "../../../utils";
import EndpointList from "./EndpointList";
const ServiceDetails = ({ service, rowIndex, }) => {
    const dispatch = useReportDispatch();
    const filter = useReportSelector(selectFilter);
    const focusedRow = useReportSelector(selectFocusedRow);
    const isExpanded = useReportSelector((state) => selectExpandedRow(state, service.id));
    return (React.createElement(DataTable.ExpandedRow, { id: `saasbom-expand-row-${rowIndex}`, expanded: isExpanded, onChange: (expanded) => dispatch(expandedRowsUpdated({
            id: service.id,
            expand: expanded,
        })), focused: focusedRow === service.id, onClick: () => dispatch(focusedRowUpdated(service.id)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(ValueOrPlaceholder, { value: service.provider })),
            React.createElement(Table.Cell, null,
                React.createElement(ServiceSummary, { name: service.name, version: service.version, searchRegex: filter.name })),
            React.createElement(Table.Cell, null, SERVICE_TYPE_TO_TEXT[service.type]),
            React.createElement(Table.Cell, null, capitalizeFirstLetter(service.flow)),
            React.createElement(Table.Cell, null,
                React.createElement(ValueOrPlaceholder, { value: service.auth ? "Yes" : undefined })),
            React.createElement(Table.Cell, null, service.endpoint_count.toLocaleString())),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(ExpandedRowDetails.Aside, null,
                    React.createElement(Card.Card, null,
                        React.createElement(Card.Title, null, "Service card"),
                        React.createElement(Card.Content, null, React.createElement(KeyValueList, { list: {
                                Provider: React.createElement(ValueOrPlaceholder, { value: service.provider }),
                                Service: service.name,
                                Version: service.version,
                                Type: SERVICE_TYPE_TO_TEXT[service.type],
                                Flow: capitalizeFirstLetter(service.flow),
                                Auth: service.auth ? "Required" : "Not required",
                            } }))),
                    React.createElement(IssuesList, { violations: service.violations, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE })),
                React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(EndpointList, { serviceId: service.id, endpointCount: service.endpoint_count, rowIndex: rowIndex }))))));
};
export default ServiceDetails;
//# sourceMappingURL=ServiceDetails.js.map